export { Amazon } from './Amazon'
export { AmazonButton } from './AmazonButton'
export { Applestore } from './Applestore'
export { ApplestoreButton } from './ApplestoreButton'
export { Miapp } from './Miapp'
export { MiappButton } from './MiappButton'
export { Playstore } from './Playstore'
export { PlaystoreButton } from './PlaystoreButton'
